// The Vue build version to load with the `import` command
// (runtime-only or standa lone) has been set in webpack.base.conf with an alias.s
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import MoowButton from '@/components/interface/buttons/moowButton.vue'
import BaseDatePicker from '@/components/interface/datetime/BaseDatePicker.vue'
import MoowInput from '@/components/interface/input/moowInput.vue'
import MoowInputSingle from '@/components/interface/input/moowInputSingle.vue'
import MoowCheckbox from '@/components/interface/input/baseCheckbox.vue'
import BaseEmptyState from '@/components/interface/empty-state/baseEmptyState.vue'
import MoowAvatar from '@/components/interface/moowAvatar.vue'
import MoowNotification from '@/components/interface/dialogs/moowNotification.vue'
import AnimButton from '@/components/interface/buttons/AnimButton.vue'
import MoowDialogConfirm from '@/components/interface/dialogs/moowDialogConfirm.vue'
import HeaderBasic from '@/components/HeaderBasic.vue'
import AltHeader from '@/components/header/AltHeader.vue'
import MainHeader from '@/components/header/MainHeader.vue'
import MasterHeader from '@/components/header/MasterHeader.vue'
import Vuex from 'vuex'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './vuex/store'
import ToggleButton from 'vue-js-toggle-button'
import VuejsDialog from "vuejs-dialog"
import VeeValidate from 'vee-validate'
import vuescrollto from 'vue-scrollto'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueChatScroll from 'vue-chat-scroll'
import { MdBottomBar, MdApp, MdSnackbar, MdTable, MdEmptyState, MdDialog, MdDivider, MdDatepicker, MdSteppers, MdBadge, MdDrawer, MdToolbar, MdSpeedDial, MdChips, MdRipple, MdCard, MdButton, MdContent, MdTabs, MdIcon, MdAvatar, MdField, MdRadio, MdAutocomplete, MdProgress, MdMenu, MdList } from 'vue-material/dist/components'
import Datepicker from 'vuejs-datepicker'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import VueProgressiveImage from 'vue-progressive-image'
import { initiateUser, getUser } from './users/services/userService.js'
import clampy from '@clampy-js/vue-clampy';
import VueClazyLoad from 'vue-clazy-load';
import { initiateReporting } from '@/utils/reporting/reportingService.js'
import VueObserveVisibility from 'vue-observe-visibility'
import VueTheMask from 'vue-the-mask'
import InfoToggle from "@/components/interface/buttons/infoToggle.vue";

import { firebase } from '@firebase/app'
import '@firebase/auth'
import '@firebase/analytics'

window.Vue = Vue;
Vue.mixin({
  methods: {
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1)
  }
})
Vue.use(VueTheMask)
Vue.use(VueObserveVisibility)
Vue.use(VueProgressiveImage)
Vue.use(VueMaterial)
Vue.use(VeeValidate)
Vue.use(VuejsDialog)
Vue.use(ToggleButton)
Vue.use(ElementUI)
Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.use(vuescrollto)
Vue.use(MdButton)
Vue.use(MdContent)
Vue.use(MdButton)
Vue.use(MdIcon)
Vue.use(MdAvatar)
Vue.use(MdField)
Vue.use(MdRadio)
Vue.use(MdAutocomplete)
Vue.use(MdProgress)
Vue.use(MdMenu)
Vue.use(MdList)
Vue.use(MdCard)
Vue.use(MdRipple)
Vue.use(MdChips)
Vue.use(MdSpeedDial)
Vue.use(MdToolbar)
Vue.use(MdTabs)
Vue.use(MdDrawer)
Vue.use(MdBadge)
Vue.use(MdSteppers)
Vue.use(MdDivider)
Vue.use(MdDatepicker)
Vue.use(MdDialog)
Vue.use(MdEmptyState)
Vue.use(MdTable)
Vue.use(MdSnackbar)
Vue.use(MdApp)
Vue.use(VueChatScroll)
Vue.use(MdBottomBar)
Vue.use(clampy);
Vue.use(VueClazyLoad);


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDEVLdrir4-QxnTFEnFDhw5NSeil9jWqg0',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
})

Vue.config.productionTip = false
Vue.component('nav-basic', HeaderBasic)
Vue.component('nav-default', MainHeader)
Vue.component('nav-master', MasterHeader)
// Vue.component('nav-default', Header)
Vue.component('header-alt', AltHeader)
Vue.component('header-main', MainHeader)
Vue.component('datepicker', Datepicker)
Vue.component('moow-avatar', MoowAvatar)
Vue.component('moow-button', MoowButton)
Vue.component('moow-checkbox', MoowCheckbox)
Vue.component('date-picker', BaseDatePicker)
Vue.component('moow-empty-state', BaseEmptyState)
Vue.component('moow-input', MoowInput)
Vue.component('moow-input-single', MoowInputSingle)
Vue.component('info-toggle', InfoToggle)
Vue.component('moow-notification', MoowNotification)
Vue.component('anim-button', AnimButton)
Vue.component('moow-dialog-confirm', MoowDialogConfirm)
Vue.prototype.$incomplete_fields = {
  title: 'Notification',
  message: 'Please complete all fields'
}
let app;
var config = {};
if (process.env.NODE_ENV == "production") {
  config = {
    // apiKey: "AIzaSyCcVxB0DkEM43uRu2drSO3dMUMT2yquGxU",
    apiKey: "AIzaSyBVUgobRpImXBykzKtjuo_F0IKs8IzRfxU",
    authDomain: "maakler-178918.firebaseapp.com",
    databaseURL: "https://maakler-178918.firebaseio.com",
    projectId: "maakler-178918",
    storageBucket: "maakler-178918.appspot.com",
    messagingSenderId: "211672574732",
    appId: "1:211672574732:web:026d689be40eceac95b729",
    measurementId: "G-QWX2YDD425"
  };
  console.log("Connected PRODUCTION firebase")
  initiateReporting();
} else {
  config = {
    apiKey: "AIzaSyDcUX5E-QCZjCGGPAhPM-mMZC02Vi4qiVE",
    authDomain: "moowle-dev.firebaseapp.com",
    databaseURL: "https://moowle-dev.firebaseio.com",
    projectId: "moowle-dev",
    storageBucket: "moowle-dev.appspot.com",
    messagingSenderId: "761346337084",
    appId: "1:761346337084:web:5de314a35007d17b9ad639",
    measurementId: "G-EBC2X3FWH4"
  };
  console.log("Connected STAGING firebase")
}

firebase.initializeApp(config);
firebase.analytics();
firebase.auth().onAuthStateChanged(function (user) {
  if (user && !user.isAnonymous) {
    store.commit("SET_USER_UID", user.uid)
    sessionStorage.setItem('signedIn', true)
    sessionStorage.setItem('liu_displayname', user.displayName)
    sessionStorage.setItem('liu_email', user.email)
    sessionStorage.setItem('liu_photoURL', user.photoURL)
    sessionStorage.setItem('liu_phoneNumber', user.phoneNumber)
    sessionStorage.setItem('liu_uid', user.uid)
    //console.log('user.uid:', user.uid);
    store.commit("IS_LOADING_USER", true)
    store.commit("SET_IS_LOGGED_IN", true)
    store.commit("SET_ACCOUNT_INITIATED", false)


    // Race condition mitigaition: 
    // When firebase auth change is triggered with new registrations, the user is in fb but not yet in our internal DB, thus get User will fail.
    // To solve this, the following is instead done inside the Registration module
    var isUserNew = JSON.parse(sessionStorage.getItem('user_just_registered'))
    if (!isUserNew) {
      setUpUserAndAccounts(user)
    }

  } else {
    store.dispatch("logout");
  }
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      template: '<App/>',
      components: { App },
      store,
      created() {
        // if(Object.keys(store.getters.user).length === 0){
        //
        // }
      },
      methods: {

      },
      computed: {
        chatEnabled() {
          return store.getters.chatEnabled
        },
      },
      watch: {
        chatEnabled(newValue, oldValue) {
          if (newValue && store.getters.user) {
            this.$store.dispatch('initiateChat', store.getters.user.uid);
          }
        }
      },
      data() {
        return {}
      }
    });
  };
});

let setUpUserAndAccounts = async (user) => {
  try{
    var domainUser = await getUser(user.uid)
    if(!domainUser) throw "getting user failed"
    initiateUser({domainUser: domainUser, authUser: user})
  }catch(ex){
    router.push({
      name: "login",
    });
    store.dispatch("logout");
  }
}


// WEBPACK FOOTER //
// ./src/main.js